import { Box, Card, CardContent, Dialog, IconButton, MenuItem, Modal, Select, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Unstable_NumberInput as NumberInput, numberInputClasses } from '@mui/base/Unstable_NumberInput';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import {colors} from '../styles/colors'
import { modal_style } from "styles/modal_style";
import { ContactPageOutlined, Title } from "@mui/icons-material";
import { loginSelector } from "store/slices/loginSlice";
import { useSelector } from "react-redux";
import { get, post } from "api/apiBridges/httpBridge";
import _ from "lodash";
import { Save } from "react-feather";
import { TabPanel } from "components/tabPanel";
import { Calculator } from "components/Calculator";
import EditIcon from '../images/others/EditIcon.png';
import { changeLanguage } from "i18next";
import { el, te } from "date-fns/locale";
import { getDataSource } from "api/ds";
import Scrollbars from "rc-scrollbars";
import { useLocalNotifications } from "components/Events";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import handleConfirm from "components/AlertMessage";
import DeleteIcon from '@mui/icons-material/Delete';
import { NumInput, TextFeature, TextInput } from "components/EIComponents/LittleComponents";
import Loading from 'components/Load';
import { ShowModal } from "components/Modal";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddIcon from '../images/others/AddIcon.png';
import { hoverStyle } from "styles/main";

export function HandBook() {
    
    const [$data, $setData] = useState([])
    const [$funcs, $setFuncs] = useState([])
    const [usedNames, setUsedNames] = useState([])
    const [calcPages, setCalcPages] = useState([])
    const [calcPage, setCalcPage] = useState(0)
    const [loading, setLoading] = useState(true);
    const [changed, setChanged] = useState([]);
    const [changedFuncs, setChangedFuncs] = useState([]);
    const [tabIdx, setTabIdx] = useState(0);
    const [calcTabs, setCalcTabs] = useState([])
    

    const handleChange = (event, newValue) => setTabIdx(newValue);

    const ds = getDataSource('hanbookPlaceList').descr

    const { company_id } = useSelector(
        loginSelector
      );

    useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
            console.log("company_id", company_id)
            const responseData = await get('Handbook/get', {company_id});
            let res = []
            let funcs = []

            if (responseData.message){
              responseData.message.map((el) => {
                let elData = JSON.parse(el.data)
                // console.log("elData", elData, ds.items[0] )
                if (elData.type === "func") {
                  funcs.push(
                    {
                      id:el.id, 
                      size:'200px',
                      status: '2',
                      name:el.name, 
                      title: elData.title,
                      hbtype:elData.type,
                      rowPlace: elData.rowPlace || ds.items[0],
                      type:'func',
                      val:elData.val, 
                      values:elData.values,
                      example: elData.example || [],
                      //todo добавить title
                      data:{name:el.name, showName:elData.title, refValue:elData.val, value:elData.val, hbtype:elData.type,}
                    }
                  )
                }
                else {
                  res.push(
                    {
                      id:el.id, 
                      size:'150px',
                      status: '4',
                      name:el.name, 
                      title: elData.title,
                      hbtype:elData.type,
                      rowPlace: elData.rowPlace || ds.items[0],
                      type:'var',
                      val:elData.val, 
                      values:elData.values,
                      data:{name:el.name, showName:elData.title, refValue:elData.val, value:elData.val, hbtype:elData.type,}
                    }
                  )
                }
                
              })
            }
            // for (let rp of StatickVarList) {
            //   let idx = res.findIndex((el) => el.rowPlace.val === rp.rowPlace.val)
            //   if (idx === -1) {
            //     let newStatic = await post("Handbook/add", {name:rp.name, company_id:company_id, data: {type: rp.hbtype, val:undefined, title:rp.title, values:rp.values || [], rowPlace: rp.rowPlace}})
            //     console.log("newStatic", newStatic)
            //     res.push(
            //       {
            //         id:newStatic.message.id, 
            //         size:'200px',
            //         status: '2',
            //         name:rp.name, 
            //         title: rp.title,
            //         hbtype:rp.hbtype,
            //         rowPlace: rp.rowPlace,
            //         type:'var',
            //         val:undefined, 
            //         values:rp.values || [],
            //         data:{name:rp.name, showName:rp.title, refValue:undefined, value:undefined, hbtype:rp.hbtype}
            //       }
            //     )
            //   }
            // }
            console.log("REEEEEEEEEEEEEES", res)
            $setData(res);
            $setFuncs(funcs);
          } catch (err) { console.log('err', err)
          } finally {
            setLoading(false);
          }
        };
    
        fetchData();
      }, []); 

      // useEffect(() => {
      //   let tmp = []
      //   $data.map((el) => {tmp.push(el.name)})
      //   $funcs.map((el) => {tmp.push(el.name)})
      //   setUsedNames(tmp)
      // }, [$data, $funcs])

      //todo переделать формат, чтобы хранить меньше данных
      // const save = async (row) => {
      //   if (row.id){
      //     await post("Handbook/update", {id:row.id, name:row.name, data: {type: row.hbtype, val:row.val, title:row.title, values:row.values, rowPlace: row.rowPlace, example: row.example}})
      //     return row.id
      //   }
      //   else {
      //    if (row.hbtype !== 'func') {
      //     let idx = $data.findIndex((el) => el.name === row.name)
      //     if (idx === -1) {
      //       const resp = await post("Handbook/add", {name:row.name, company_id:company_id, data: {type: row.hbtype, val:row.val, title:row.title, values:row.values, rowPlace: row.rowPlace}})
      //       let tmp = [...$data]
      //       tmp.push({id:resp.message.id, name: row.name, title: row.title, hbtype: row.hbtype, val:undefined, rowPlace: ds.items[0]})
      //       $setData(tmp)
      //       return resp.message.id
      //     }
      //     else {
      //       return -1
      //     }
      //    }
      //    else {
      //     let idx = $funcs.findIndex((el) => el.name === row.name)
      //     if (idx === -1) {
      //       const resp = await post("Handbook/add", {name:row.name, company_id:company_id, data: {type: row.hbtype, val:row.val, title:row.title, values:row.values, rowPlace: row.rowPlace, example: row.example}})
      //       let tmp = [...$funcs]
      //       tmp.push({
      //         id:resp.message.id, 
      //         name: row.name, 
      //         title: row.title, 
      //         hbtype: row.hbtype, 
      //         val:undefined, 
      //         rowPlace: ds.items[0], 
      //         example: row.example,
      //         data:{name:row.name, showName:row.title, refValue:undefined, value:undefined, hbtype:row.hbtype}
      //       })
      //       $setFuncs(tmp)
      //       return resp.message.id
      //     }
      //     else {
      //       return -1
      //     }
      //    }
         
      //   }
      // }

      // const delRow = async (id, type) => {
      //   await post("Handbook/delete", {vid:id})
      //   if (type !== 'func') {
      //     $setData($data.filter((el) => el.id !== id))
      //   }
      //   else {
      //     $setFuncs($funcs.filter((el) => el.id !== id))
      //   }
      // }
    
      // const onChange = (obj) => {
      //   console.log("obj", obj)
      //   let tmp = [...$data]
      //   let idx = tmp.findIndex((el) => el.id === obj.id)
      //   if (idx > -1) {
      //     tmp[idx] = obj
      //   }
      //   $setData(tmp);
      //   if (!changed.includes(obj.id)) setChanged([...changed, obj.id])
      // }

      // const onChangeFunc = (rows, id) => {
      //   console.log(id)
      //   $setFuncs(rows);
      //   if (!changedFuncs.includes(id)) setChangedFuncs([...changedFuncs, id])
      // }

      // const saveClick = async () => {
      //   console.log(changed)
      //   changed.map((id) => {
      //     const idx = $data.findIndex((el) => el.id === id);
      //     if (idx >= 0) {
      //       save($data[idx])
      //   }
      //   })
      //   setChanged([])
      // }

    // const saveClickFuncs = async () => {
    //   console.log(changedFuncs)
    //   changedFuncs.map((id) => {
    //     const idx = $funcs.findIndex((el) => el.id === id);
    //     if (idx >= 0) {
    //       save($funcs[idx])
    //   }
    //   })
    //   setChanged([])
    // }

    // const setEditCalcPage = (fid, el) => {
    //   console.log("SECP", fid, el)
    //   let idx = calcPages.indexOf(fid)
    //   if (idx==-1) {
    //     setCalcPage(calcPages.length)
    //     setCalcPages([...calcPages, fid])
    //     setCalcTabs([...calcTabs, {...el, id: fid}])
    //     setTabIdx(3)
    //   }
    //   else {
    //     setCalcPage(idx)
    //     setTabIdx(3)
    //   }
    // }

    // const saveFormula = async (formula) => {
    //   console.log('formula', formula)
    //   let temp = [...$funcs]
    //   console.log('formula temp', temp)
    //   let idx = temp.findIndex((el) => (el.id === formula.id))
    //   console.log('formula idx', idx)
    //   if (idx >-1) {
    //     temp[idx].example = formula.example
    //     $setFuncs(temp)
    //     await save(temp[idx])
    //   }


    // }

    const onChangeStaticRow = async (inData) => {
      console.log("inData", inData)
      let tmp = JSON.parse(JSON.stringify($data))
      let idx = tmp.findIndex((el) => el.id === inData.id)
      tmp[idx] = inData
      $setData(tmp)
      console.log("tmp[idx]", tmp[idx])
      // await post("Handbook/update", {id: inData.id, data: tmp[idx]})
      await post("Handbook/update", {id:inData.id, data: {type: tmp[idx].hbtype, val:tmp[idx].val, title:tmp[idx].title, values:tmp[idx].values, rowPlace: tmp[idx].rowPlace}})
    } 

    const checkFreename = (checkName) => {
      for (let el of $data) {
        if (el.values) {
          for (let val of el.values) {
            if (checkName === val.name) return false
          }
        }
      }
      return true
    }

    if (loading) return (<Loading></Loading>)
    return (
        <Box sx={{ width: '100%', height: '100%' }}>    
          {
            <>
              <Box component="div" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIdx} aria-label="basic tabs example" onChange={handleChange}>
                  <Tab label='Основное' value={0}/>
                  {/* <Tab label='Переменные' value={1}/>
                  <Tab label='Функции' value={2} />
                  <Tab label='Редактор формул' value={3} /> */}
                </Tabs>
              </Box>
              <TabPanel select={tabIdx} value={0}>
              
                    <div style={{ width: '100%', display: 'flex', flexDirection: "row", flexWrap: "wrap", gap: "20px", alignItems: "flex-start" }}>
                      {
                        $data
                          .filter((el) => el.rowPlace.val.slice(0, 7) === "static.")
                          .sort((a, b) => a.name !== "product_package" ? -1 : 1)
                          .map((el) => (
                            <HandBookStaticCard 
                              key={el.id} 
                              row={el} 
                              onChange={(inData) => { onChangeStaticRow(inData) }} 
                              freeName={checkFreename} 
                            />
                          ))
                      }
                    </div>
                
              </TabPanel>
              {/* <TabPanel select={tabIdx} value={1}>
                { changed? <Button onClick={saveClick}>Сохранить изменения</Button>: <></>}
                <Scrollbars
                    style={{height: "90%"}} autoHide
                >
                  <HandBookTable data={$data.filter((el) => el.rowPlace.val.slice(0,7) !== "static.")} usedNames={usedNames} onChange={(obj) => {onChange(obj)}} saveMet = {save} ds={ds} onDel={delRow}/>
                </Scrollbars>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '95%', marginTop: '-2%' }}>
                  <Button 
                      onClick={saveClickFuncs}
                      variant="contained" 
                      sx={{ 
                      textTransform: 'none', 
                      backgroundColor: colors.elements, 
                      fontWeight: 'bold', 
                      marginRight: '10px' 
                      }} 
                  >
                      Применить
                  </Button>
              </div>
              </TabPanel>
              <TabPanel select={tabIdx} value={2}>
                <Scrollbars
                    style={{height: "90%"}} autoHide
                >
                  <FuncsTable 
                    data={$funcs} 
                    usedNames={usedNames}
                    onChange={(rows, id) => {onChangeFunc(rows, id)}} 
                    saveMet = {save}
                    addCalcTabs={(fid, el) => {setEditCalcPage(fid, el)}}
                    ds={ds}
                    onDel={delRow}
                  />
                </Scrollbars>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '95%', marginTop: '-2%' }}>
                    <Button 
                      onClick={saveClickFuncs}
                      variant="contained" 
                      sx={{ 
                      textTransform: 'none', 
                      backgroundColor: colors.elements, 
                      fontWeight: 'bold', 
                      marginRight: '10px' 
                      }} 
                    >
                        Применить
                    </Button>
                </div>
              </TabPanel>
              <TabPanel select={tabIdx} value={3}>
                <Calculator show={calcTabs} defaultIndex={calcPage} variables={$data} Formulas={$funcs} onSave={(data) => {saveFormula(data)}}></Calculator>
              </TabPanel> */}
            </>
          }
        </Box>
    );

}

const elOfType = (row, setValue, handleEnumModalOpen, onChange) => {

  const del = (obj, index) => {
    console.log(index)
    let tmp = JSON.parse(JSON.stringify(obj))
    tmp.values.splice(index, 1)
    onChange(tmp)
  }

  const editNumValue = (obj, index, val) => {
    let tmp = JSON.parse(JSON.stringify(obj))
    tmp.values[index].val = val
    onChange(tmp)
  }

  switch(row.hbtype){
    case 'fix':
      return (
        <NumberInput
          placeholder="Type a number…"
          value={row.val}
          onChange={(event, val) => setValue(row.id, val)}
          style={{borderRadius:"8px"}}
          slots={{
              root: StyledInputRoot,
              input: StyledInputElement,
              incrementButton: StyledButton,
              decrementButton: StyledButton,
          }}
          slotProps={{
              incrementButton: {
                  children: '▴',
              },
              decrementButton: {
                  children: '▾',
              },
          }}
        />
      );
    case 'input':
      return (<></>)
    case 'enum':
      console.log("row", row)
      return (
        <Select
          multiple
          value={row.values}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          style={{
              width:"300px",
              borderRadius: "15px",
              fontSize: "15px",
              marginRight: "2px",
              height: "40px"
          }}
          renderValue={(selected) => selected.map((el) => el.name).join(', ')}
        >
          {row.values && row.values.map((el, index) => (
            <MenuItem key={el.id} value={el}>
              <div style={{width: '100%', display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                  <TextInput title={el.name} val={el.val} onChange={(e) => editNumValue(row, index, e)}></TextInput>
                </div>
                {el.static? <></>: 
                <IconButton  aria-label="delImage" onClick={() => {del(row, index)}} 
                  sx={{
                    width: 40,
                    height: 40,
                  }}
                >
                    <DeleteIcon 
                      sx={{
                        transition: 'all 0.3s ease',
                        '&:hover': hoverStyle
                      }
                    }/>
                </IconButton>
                }
              </div>
            </MenuItem>
          ))}
          <Button onClick={() => handleEnumModalOpen(row.id)}>Добавить</Button>
        </Select>
      )
  }
}

function HandBookStaticCard({row, onChange, freeName}) {

    const [data, setData] = useState(undefined)

    const [addOpen, setAddOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    

    useEffect(() => {
        console.log("row", row)
        setData(row)
     
    }, [row]);

    const addField = ($data) => {
      let tmp = JSON.parse(JSON.stringify(data))
      if (tmp.values) {tmp.values.push($data)}
      else {tmp.values = [$data]}
      onChange(tmp)
      setData(tmp)
    }

    const delField = (idx) => {
      let tmp = JSON.parse(JSON.stringify(data))
      tmp.values.splice(idx, 1)
      onChange(tmp)
      setData(tmp)
    }

    const editField = ($data, idx) => {
      let tmp = JSON.parse(JSON.stringify(data))
      _.set(tmp, `values[${idx}]`, $data)
      onChange(tmp)
      setData(tmp)
    }


    return (
        <Card sx={{ 
            margin: "20px", 
            width: "350px",
            borderRadius: "16px", 
            height: "fit-content",
            boxShadow: '0px 4px 20px rgba(0,0,0,0.05)'
        }}>
            <Modal open={addOpen} onClose={() => setAddOpen(false)}>  
                <HBSFieldEdit field={undefined} type={data?.name} onCancel={() => setAddOpen(false)} onSave={($data) => addField($data)} freeName={freeName}/>
            </Modal>
            
            <CardContent>
                {/* Заголовок с кнопками управления */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, px: 1 }}>
                    <Typography sx={{ fontSize: '24px', color: '#300342f' }}>
                        {data?.title}
                    </Typography>
                    <Box>
                        <IconButton onClick={() => setIsEditing(!isEditing)} sx={{ color: isEditing ? '#208f84' : 'inherit' }}>
                <img alt="" src={EditIcon} width={25} height={25}></img>
              </IconButton>
              <IconButton onClick={() => setAddOpen(true)}>
                <img alt="" src={AddIcon} width={25} height={25}></img>
              </IconButton>
                    </Box>
                </Box>

                <Box sx={{ 
                    width: '100%', 
                    maxHeight: '600px',
                    overflowY: 'auto',
                    pr: 1,
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-thumb': { background: '#e0e0e0', borderRadius: '10px' }
                }}>
                    {data?.values && data?.values.map((el, index) => (
                        // @ts-ignore
                        <HBSField 
                            key={index}
                            obj={el} 
                            isEditing={isEditing}
                            onEdit={($data) => editField($data, index)} 
                            onDel={() => delField(index)}
                            staticField={el.static}
                        />
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
  }

function HBSField ({obj, isEditing, type, staticField, onDel, onEdit, freeName}) {

  const [editOpen, setEditOpen] = useState(false);

  const del = () => {
    ShowModal(
        'Удаление',
        <div>Вы уверены, что хотите удалить переменную?</div>,
        async () => {
            onDel()
        }
    );
  }

  const handleChange = (path, value) => {
    onEdit({ ...obj, [path]: value });
  };

  return (
    <div style={{ 
      width: '100%', 
      display: 'flex', 
      flexDirection: "row", 
      alignItems: "center",
      padding: "4px 0",
      marginBottom: "8px"
    }}>
      {isEditing && !staticField ? (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', padding:'10px' }}>
          <TextField 
            variant="standard" 
            value={obj.name} 
            onChange={(e) => handleChange('name', e.target.value)}
            InputProps={{ disableUnderline: false }}
            sx={{ 
                flex: 1,
                '& .MuiInput-input': { 
                    fontSize: '18px', 
                    color: '#838383',
                    marginTop:'18px',
                    padding: 0
                } 
            }}
          />
          <TextField 
            variant="standard" 
            value={obj.val} 
            onChange={(e) => handleChange('val', e.target.value)}
            InputProps={{ disableUnderline: false }}
            sx={{ 
                width: '100px',
                marginRight: '20px',
                '& .MuiInput-input': { 
                    textAlign: 'right',
                    fontSize: '30px', 
                    fontWeight: '500', 
                    color: '#838383',
                    padding: 0
                } 
            }}
          />
          <IconButton onClick={() => {del()}} size="small" >
            <DeleteIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', padding:'10px' }}>
          <Typography sx={{ fontSize: '18px', color: '#838383' }}>{obj.name}</Typography>
          <Typography sx={{marginRight:'20px', fontSize: '30px', fontWeight: '500', color: '#838383' }}>
            {obj.val}
          </Typography>
        </Box>
      )}
    </div>
  );
}


function HBSFieldEdit ({field, type, onSave, onCancel, edit = false, freeName}) {

  const [obj, setObj] = useState(undefined)
  const [free, setFree] = useState(true)

  useEffect(() => {
      if (field) {
        setObj(field)
      }    
      else {setObj({})}
  }, [field]);

  const setVal = (path, val) => {
    let tmp = JSON.parse(JSON.stringify(obj))
    _.set(tmp, path, val)
    if (path === 'name' ) {setFree(freeName(val))}
    setObj(tmp)
  }
  
  const { showNotification } = useLocalNotifications();

  const save = () => {
    if (free) {
      if (edit) {
        ShowModal(
            'Редактирование',
            <div>Вы уверены, что хотите сохранить изменения?</div>,
            async () => {
                onSave(obj); 
                onCancel()
            }
        );
      }
      else {
        onSave(obj); 
        onCancel()
      }
    }
    else {
      showNotification({
          id: 'CreateEr', 
          type: 'error', 
          message: 'Переменная с таким именем уже существует' 
      });
    }
  }


  return (
    <Box sx={{ 
        ...modal_style, 
        borderRadius: '15px', 
        padding: '40px',
        border: 'none',
        boxShadow: '0px 10px 40px rgba(0,0,0,0.1)',
        width: '480px',
        height:'350px'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
          
          <Typography sx={{ fontSize: '30px', color: '#300342f' }}>
            {edit ? "Редактирование" : "Добавить новое значение"}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center',marginLeft:'30px' }}>
              <Typography sx={{ fontSize: '24px', fontWeight:'450', color: '#838383' }}>Название</Typography>
              <Tooltip title={free ? "Имя свободно" : "Имя занято"}>
                <CheckCircleOutlineIcon sx={{ 
                  color: free ? '#208f84' : '#f87d83', 
                  height: "16px", 
                  width: "16px", 
                  marginLeft: "6px" 
                }} />
              </Tooltip>
            </Box>
            <TextField 
              variant="standard"
              value={obj?.name || ""}
              onChange={(e) => setVal("name", e.target.value)}
              sx={{ 
                width: '55%',
                '& .MuiInput-input': { 
                  textAlign: 'center', 
                  fontSize: '30px', 
                  color: '#838383',
                  fontWeight:'500'
                } 
              }}
            />
          </Box>
          {type === "product_package" && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',marginLeft:'30px' }}>
              <Typography sx={{ fontSize: '24px', fontWeight:'450', color: '#838383' }}>Размер</Typography>
              <TextField 
                variant="standard"
                value={obj?.size || ""}
                onChange={(e) => setVal("size", e.target.value)}
                sx={{ 
                  width: '60%',
                  '& .MuiInput-input': { 
                    textAlign: 'center', 
                    fontSize: '30px', 
                    color: '#838383',
                    fontWeight:'500'
                  } 
                }}
              />
            </Box>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',marginLeft:'30px' }}>
            <Typography sx={{ fontSize: '24px', fontWeight:'450', color: '#838383', pb: 1 }}>Цена</Typography>
            <TextField 
              variant="standard"
              value={obj?.val || ""}
              onChange={(e) => setVal("val", e.target.value)}
              sx={{ 
                width: '60%',
                '& .MuiInput-input': { 
                  textAlign: 'center', 
                  fontSize: '30px', 
                  color: '#838383',
                  fontWeight:'500'
                } 
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '130px', mt: 2 }}>
            <Button sx={{fontSize:'18px'}}onClick={() => onCancel()}>
              ОТМЕНА
            </Button>
            <Button 
              variant="contained"
              onClick={() => save()}
              sx={{ 
                borderRadius: '8px', 
                padding: '8px 20px', 
                backgroundColor: '#208f84',
                textTransform: 'none',
                fontSize: '16px',
                '&:hover': { backgroundColor: '#1a7a70' }
              }}
            >
              {edit ? "СОХРАНИТЬ" : "ДОБАВИТЬ"}
            </Button>
          </Box>
        </div>
      </Box>
    )
}

function HandBookTable({data, onChange, saveMet, ds, onDel, usedNames}) {

    console.log("data", data)
    const [rows, setRows] = useState([])

    const [varsModalOpen, setVarsModalOpen] = useState(false);
    const handleVarsModalOpen = () => setVarsModalOpen(true);
    const handleVarsModalClose = () => setVarsModalOpen(false);
    const [varsModalName, setVarsModalName] = useState(undefined);
    const [varsModalTitle, setVarsModalTitle] = useState(undefined);
    const [varsModalType, setVarsModalType] = useState('fix');

    const { showNotification } = useLocalNotifications();

    const addNewVar = async () => {
      console.log(varsModalName, varsModalType)
      if (!varsModalName || !varsModalType || !varsModalTitle)  {
        showNotification({
          id: 'CreateEr', 
          type: 'error', 
          message: 'Не все поля заполнены' 
        });
        return 0;
      }
      if (varsModalName.includes(' ')) {
        showNotification({
            id: 'CreateEr', 
            type: 'error', 
            message: 'Название не должно содержать пробелов' 
        });
        return 0;
      }
      if (usedNames.includes(varsModalName)) {
        showNotification({
            id: 'CreateEr', 
            type: 'error', 
            message: 'Переменная с таким именем уже существует' 
        });
        return 0;
      }
      await saveMet({name: varsModalName, title:varsModalTitle, hbtype: varsModalType})
      handleVarsModalClose()
      setVarsModalName(undefined)
      setVarsModalType('fix')
    }

    const [enumModalOpen, setEnumModalOpen] = useState(false);
    const [enumAddId, setEnumAddId] = useState(undefined);
    const handleEnumModalOpen = (id) => {setEnumModalOpen(true); setEnumAddId(id)}
    const handleEnumModalClose = () => {setEnumModalOpen(false); setEnumAddId(undefined)}
    const [enumModalName, setEnumModalName] = useState(undefined);
    const [enumModalVal, setEnumModalVal] = useState(undefined);

    const addNewEnumVar = () => {
      console.log("new enum val", enumModalName, enumModalVal)
      if (enumModalName && enumModalVal)  {
        let R = [...rows]
        console.log(enumAddId)
        console.log("find", R.find((el) => (el.id === enumAddId)))
        
        let p = R.findIndex((el) => (el.id === enumAddId))
        console.log("p", p)
        if (p>-1) {
          if (R[p].values && R[p].values.length>0) {
            R[p].values?.push({name:enumModalName, val: enumModalVal})
          }
          else {
            R[p].values = [{name:enumModalName, val: enumModalVal}]
            R[p].val = R[p].values[0]
          }
          setRows(R)
          if (onChange){onChange(R[p])}
        }
          
        handleEnumModalClose()
        setEnumModalName(undefined)
        setEnumModalVal(undefined)
      }
    }

    useEffect(() => {
        setRows(data)
     
    }, [data]);

    console.log("HBT", rows)


    const setValue = (id, val) => {
      const idx = rows.findIndex((el) => el.id === id);
      if (idx >= 0) {
          rows[idx] = {...rows[idx], val:val}
          if (onChange){onChange({...rows[idx]})}
          setRows(JSON.parse(JSON.stringify(rows)))
      }

    }

    const changeRowPlace = (rid, val) => {
      let temp = JSON.parse(JSON.stringify(rows))
      let idx = temp.findIndex((el) => (el.id === rid))
      if (idx>-1) {
        temp[idx].rowPlace = {val, title: ds.items.find((el) => (el.val === val))}
        if (onChange){onChange({...temp[idx]})}
        setRows(temp)
      }
    }

    const delVar = (rid, type) => {
      if (onDel){
        handleConfirm('Вы уверены что хотите удалить переменную?', () =>{onDel(rid, type)});
      } 
    }

    const handleClickDelVar = (rid, type) => {
        ShowModal('Удалить переменную', 
        <div>Вы уверены, что хотите удалить переменную?</div>, 
        async () => {
            try {
            if (onDel){
              onDel(rid, type);} 
            }
            catch (err) {}
            finally {}
            
        });
    }

    return (
      <>
        {/* окно для добавления переменной */}
        <Modal
          open={varsModalOpen}
          onClose={handleVarsModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modal_style}>
            <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
            <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'10px'}}>Добавить новую переменную</Typography>
            <TextField variant="filled" label="Название" onChange={(e) => {setVarsModalName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <TextField variant="filled" label="Отображаемое имя" onChange={(e) => {setVarsModalTitle(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <Select
              style={{width:"100%", marginTop:'5px', borderRadius:"8px"}}
              defaultValue='fix'
              value={varsModalName}
              onChange={(event) => {console.log(event.target.value); setVarsModalType(event.target.value)}}
            >
              <MenuItem value={'fix'}>{'fix'}</MenuItem>
              <MenuItem value={'input'}>{'input'}</MenuItem>
              <MenuItem value={'enum'}>{'enum'}</MenuItem>
            </Select>
            <Button onClick={handleVarsModalClose}>Отмена</Button>
            <Button onClick={addNewVar}>Добавить</Button>
            </div>
          </Box>  
        </Modal>

        {/* окно для добавления значения enum */}
        <Modal
          open={enumModalOpen}
          onClose={handleEnumModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modal_style}>
            <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
            <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'10px'}}>Добавить новое значение</Typography>
            <TextField variant="filled" label="Название" onChange={(e) => {setEnumModalName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <TextField variant="filled" label="Значение" onChange={(e) => {setEnumModalVal(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <Button onClick={handleEnumModalClose}>Отмена</Button>
            <Button onClick={addNewEnumVar}>Добавить</Button>
            </div>
          </Box>  
        </Modal>

        {/* Основная таблица справоочиника */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead sx={{height:"60px"}}>
              <TableRow>
                <TableCell>Отображаемое имя</TableCell>
                <TableCell>Название</TableCell>
                <TableCell align="left">Тип</TableCell>
                <TableCell align="left">Где отображать</TableCell>
                <TableCell align="left">Значение</TableCell>
                <TableCell align="right">
                  <Button 
                      onClick={handleVarsModalOpen}
                      variant="contained"
                      size="medium"
                      sx={{
                          textTransform: "none",
                          fontWeight: "bold",
                          width: "150px",
                          marginLeft:"5px",
                          marginRight:"5px"
                      }}
                  >
                      Добавить
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell style={{width:"15%"}} align="left">{row.title}</TableCell>
                  <TableCell style={{width:"15%"}} align="left">{row.name}</TableCell>
                  <TableCell style={{width:"15%"}} align="left">{row.hbtype}</TableCell>
                  <TableCell style={{width:"15%"}} align="left">
                    {ds?.items? 
                    <Select
                      style={{width:"100%"}}
                      value={row.rowPlace.val}
                      onChange={(event) => changeRowPlace(row.id, event.target.value)}
                    >
                      {ds.items.map((v) => {return(<MenuItem value={v.val}>{v.title}</MenuItem>)})}
                    </Select>: <></>
                    }
                  </TableCell>
                  <TableCell style={{width:"30%"}} align="left"> 
                    {elOfType(row, setValue, handleEnumModalOpen)} 
                  </TableCell>
                  <TableCell style={{width:"30%"}} align="left"> 
                    <IconButton aria-label="delete" onClick={() => handleClickDelVar(row.id, row.hbtype)}>
                        <DeleteForeverIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }
  
  
function FuncsTable({data, onChange, saveMet, addCalcTabs, ds, onDel, usedNames}) {

    console.log("FT data", data)
    const [rows, setRows] = useState([])

    const [varsModalOpen, setVarsModalOpen] = useState(false);
    const handleVarsModalOpen = () => setVarsModalOpen(true);
    const handleVarsModalClose = () => setVarsModalOpen(false);
    const [varsModalName, setVarsModalName] = useState(undefined);
    const [varsModalTitle, setVarsModalTitle] = useState(undefined);

    const { showNotification } = useLocalNotifications();

    const addNewVar = async () => {
      
      console.log(varsModalName)
      if (!varsModalName || ! varsModalTitle)  {
        showNotification({
          id: 'CreateEr', 
          type: 'error', 
          message: 'Не все поля заполнены' 
        });
        return 0;
      }
      if (varsModalName.includes(' ')) {
        showNotification({
            id: 'CreateEr', 
            type: 'error', 
            message: 'Название не должно содержать пробелов' 
        });
        return 0;
      }
      if (usedNames.includes(varsModalName)) {
        showNotification({
            id: 'CreateEr', 
            type: 'error', 
            message: 'Переменная с таким именем уже существует' 
        });
        return 0;
      }
      await saveMet({name: varsModalName, title:varsModalTitle, hbtype: "func", val: [], example: []})
      handleVarsModalClose()
      setVarsModalName(undefined) 

    }

    useEffect(() => {
        
        setRows(data)
     
    }, [data]);

    const handleEditFunc = (row) => {
      addCalcTabs(row.id, 
        {name: row.name, saved:true, vars: [], example:row.example}
      )
    }

    const changeRowPlace = (rid, val) => {
      let temp = JSON.parse(JSON.stringify(rows))
      let idx = temp.findIndex((el) => (el.id === rid))
      if (idx>-1) {
        temp[idx].rowPlace = {val, title: ds.items.find((el) => (el.val === val))}
        if (onChange){onChange({...temp[idx]})}
        setRows(temp)
      }
    }

    const delVar = (rid, type) => {
      if (onDel){
        handleConfirm('Вы уверены что хотите удалить переменную?', () =>{onDel(rid, type)});
      } 
    }

    const handleClickDelVar = (rid, type) => {
        ShowModal('Удалить переменную', 
        <div>Вы уверены, что хотите удалить переменную?</div>, 
        async () => {
            try {
            if (onDel){
              onDel(rid, type);} 
            }
            catch (err) {}
            finally {}
            
        });
    }

    return (
      <>
        {/* окно для добавления переменной */}
        <Modal
          open={varsModalOpen}
          onClose={handleVarsModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modal_style}>
            <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
            <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'10px'}}>Добавить новую переменную</Typography>
            <TextField variant="filled" label="Название функции" onChange={(e) => {setVarsModalName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <TextField variant="filled" label="Отображаемое имя функции" onChange={(e) => {setVarsModalTitle(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'5px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
            <Button onClick={handleVarsModalClose}>Отмена</Button>
            <Button onClick={addNewVar}>Добавить</Button>
            </div>
          </Box>  
        </Modal>


        {/* Основная таблица справоочиника */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Отображаемое имя</TableCell>
                <TableCell>Название</TableCell>
                <TableCell align="left">Тип</TableCell>
                <TableCell align="left">Где отображать</TableCell>
                <TableCell align="left">Действия</TableCell>
                <TableCell align="right">
                  <Button 
                      onClick={handleVarsModalOpen}
                      variant="contained"
                      size="medium"
                      sx={{
                          textTransform: "none",
                          fontWeight: "bold",
                          width: "150px",
                          marginLeft:"5px",
                          marginRight:"5px"
                      }}
                  >
                      Добавить
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell style={{width:"20%"}} align="left">{row.title}</TableCell>
                  <TableCell style={{width:"20%"}} align="left">{row.name}</TableCell>
                  <TableCell style={{width:"20%"}} align="left">{row.hbtype}</TableCell>
                  <TableCell style={{width:"30%"}} align="left">
                    {ds?.items? 
                    <Select
                      style={{width:"100%"}}
                      value={row.rowPlace.val}
                      onChange={(event) => changeRowPlace(row.id, event.target.value)}
                    >
                      {ds.items.map((v) => {return(<MenuItem value={v.val}>{v.title}</MenuItem>)})}
                    </Select>: <></>
                    }
                  </TableCell>
                  <TableCell align="left">
                  <IconButton onClick={() => {handleEditFunc(row)}}>
                    <img alt="" src={EditIcon} width={25} height={25}></img>
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleClickDelVar(row.id, row.hbtype)}>
                      <DeleteForeverIcon
                          sx={{
                              transition: 'all 0.3s ease',
                              '&:hover': hoverStyle
                          }}
                      />
                  </IconButton>
                </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }
  
  const StyledInputRoot = styled('div')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    border-radius: 8px;
    border: 1px solid ${colors.gray_block};
    box-shadow: 0 2px 4px ${
      theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
    display: grid;
    grid-template-columns: 1fr 19px;
    grid-template-rows: 1fr 1fr;
    overflow: hidden;
    column-gap: 8px;
    padding: 4px;
  
    &.${numberInputClasses.focused} {
      border-color: ${colors.gray_block};
    }
  
    /* firefox */
    &:focus-visible {
      outline: 0;
    }
  `,
  );
  
  const StyledInputElement = styled('input')(
    ({ theme }) => `
    font-size: 0.875rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.5;
    grid-column: 1/2;
    grid-row: 1/3;
    background: inherit;
    border: none;
    border-radius: inherit;
    padding: 8px 12px;
    outline: 0;
  `,
  );
  
  const StyledButton = styled('button')(
    ({ theme }) => `
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    appearance: none;
    padding: 0;
    width: 19px;
    height: 19px;
    font-family: system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1;
    box-sizing: border-box;
    background: ${colors.gray_block};
    border: 0;
    color: ${colors.elements};
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
  
    &:hover {
      cursor: pointer;
      color: #FFF;
      background: ${colors.elements};
      border-color: ${colors.gray_block};
    }
  
    &.${numberInputClasses.incrementButton} {
      grid-column: 2/3;
      grid-row: 1/2;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border: 1px solid;
      border-bottom: 0;
      border-color: ${colors.gray_block};
      color: ${colors.elements};
  
      &:hover {
        cursor: pointer;
        color: #FFF;
        background: ${colors.elements};
        border-color: ${colors.gray_block};
      }
    }
  
    &.${numberInputClasses.decrementButton} {
      grid-column: 2/3;
      grid-row: 2/3;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border: 1px solid;
      border-color: ${colors.gray_block};
      color: ${colors.elements};

      &:hover {
        cursor: pointer;
        color: #FFF;
        background: ${colors.elements};
        border-color: ${colors.gray_block};
      }

    }
  
    & .arrow {
      transform: translateY(-1px);
    }
  `,
  );
